import { useMemo } from 'react';
import { Classes, Tag } from '@blueprintjs/core';
import { classNames } from '@axo/shared/util/dom';
import { ace_hooks } from '@axo/shared/data-access/hooks';
import { AceCard } from '../AceCard';
import styles from './NBACard.module.css';
import React from 'react';

interface Props {
  applicationID: string;
}

export function NBACard({ applicationID }: Props) {
  const app = ace_hooks.useApplicationBucket(applicationID);
  const bucket = ace_hooks.useBucket(app.data?.BucketID ?? '');

  const loading = useMemo(
    () => app.isLoading || bucket.isLoading,
    [app.isLoading, bucket.isLoading],
  );

  return (
    <AceCard id={`NBACard.${applicationID}`} title="Required action">
      <div className={classNames(styles.container, Classes.TEXT_SMALL)}>
        {loading ? (
          <Tag intent="success" {...tagstyle}>
            <span className={Classes.SKELETON}>%action placeholder%</span>
          </Tag>
        ) : (bucket.data?.Actions?.length ?? 0) < 1 ? (
          <Tag intent="none" {...tagstyle}>
            <em>Nothing to do</em>
          </Tag>
        ) : (
          bucket.data?.Actions?.map((action) => (
            <Tag
              key={`${action.Kind}-${action.Name}`}
              intent="success"
              {...tagstyle}
            >
              {action.Name}
            </Tag>
          ))
        )}

        <div className={styles.cols}>
          <span>Bucket name</span>
          <span className={Classes.TEXT_MUTED}>
            {loading ? (
              <span className={Classes.SKELETON}>
                %bucket name placeholder%
              </span>
            ) : (
              (bucket.data?.Name ?? <em>No bucket</em>)
            )}
          </span>
        </div>

        <div>
          <p>Action description</p>
          <p className={Classes.TEXT_MUTED}>
            {loading ? (
              <span className={Classes.SKELETON}>
                %required action placeholder text%
              </span>
            ) : (bucket.data?.Actions?.length ?? 0) < 1 ? (
              <em>No description</em>
            ) : (
              bucket.data?.Actions?.map((action, i, items) => (
                <React.Fragment key={`${action.Kind}-${action.Name}`}>
                  {items.length > 1 && i > 0 && <br />}
                  {items.length > 1 && '- '}
                  {action.Description}
                </React.Fragment>
              ))
            )}
          </p>
        </div>
      </div>
    </AceCard>
  );
}

const tagstyle = {
  minimal: true,
  round: true,
  fill: true,
  large: true,
};
